import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class WorkorderUtilityService {

  constructor() { }

  formatDate(date: string | Date): string {
    const dt = typeof date === 'string' ? new Date(date) : date;
    return dt.toLocaleString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  }

  mapSteps(workFlowSteps: any[]): MappedWorkFlowStep[] {
    if (!Array.isArray(workFlowSteps)) return [];

    return workFlowSteps.map((step, idx, arr) => {

      let status: WorkFlowStepStatus;

      if (step.isTechnicianFinalClosed || step.actionDate) {
        status = 'done';
      } else if (step.isActive) {
        status = 'current';
      } else {
        status = 'pending';
      }

      const duration = step.takeTime || step.initialTakeTime || '00:00:00';

      const timeToNext = idx < arr.length - 1 && step.actionDate && arr[idx + 1].actionDate ? this.calculateTimeDiff(step.actionDate, arr[idx + 1].actionDate) : '';

      return {
        title: step.name,
        user: step.actionBy || '',
        date: step.actionDate ? this.formatDate(step.actionDate) : '',
        duration,
        timeToNext,
        status,
      };
    });
  }

  private calculateTimeDiff(date1: string, date2: string): string {
    const t1 = new Date(date1).getTime();
    const t2 = new Date(date2).getTime();
    const diff = Math.abs(t2 - t1) / 1000;
    const h = Math.floor(diff / 3600).toString().padStart(2, '0');
    const m = Math.floor((diff % 3600) / 60).toString().padStart(2, '0');
    const s = Math.floor(diff % 60).toString().padStart(2, '0');
    return `${h}:${m}:${s}`;
  }


  open(filePath: string) {
    const base = localStorage.getItem('companyLink') ?? '';
    window.open(base + filePath, '_blank');
  }

}

export type WorkFlowStepStatus = 'done' | 'current' | 'pending';

export interface MappedWorkFlowStep {
  title: string;
  user: string;
  date: string;
  duration: string;
  timeToNext: string;
  status: WorkFlowStepStatus;
}
